import { useState } from "react";
import { motion } from "framer-motion";
import "./ZigZag.css";
import { FiChevronUp } from "react-icons/fi";

interface ZigZagProps {
  title: string;
  description: string;
  image: string;
  reverse?: boolean;
  children?: React.ReactNode; // ✅ extra content
}

const ZigZag = ({
  title,
  description,
  image,
  reverse = false,
  children,
}: ZigZagProps) => {
  const [showMore, setShowMore] = useState(false);

  // Visually, `reverse` swaps which side text/image land on via CSS `order`,
  // so the two halves must start offset toward the center from whichever
  // side they'll actually end up on, not their DOM order.
  const textStartX = reverse ? -70 : 70;
  const imageStartX = reverse ? 70 : -70;

  return (
    <section className={`zigzag ${reverse ? "reverse" : ""}`}>
      <div className="zigzag-container container">

        {/* TEXT */}
        <motion.div
          className="zigzag-text"
          initial={{ opacity: 0, x: textStartX }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true, amount: 0.4 }}
          transition={{ duration: 2.8, ease: [0.16, 1, 0.3, 1] }}
        >
          <h3>{title}</h3>
          <p>{description}</p>

          {/* SHOW MORE BUTTON (FIXED POSITION) */}
          {children && (
            <button
              className="zigzag-show-more"
              onClick={() => setShowMore(!showMore)}
            >
              <span className={`zigzag-arrow ${showMore ? "open" : ""}`}>
                 <FiChevronUp />
              </span>
              <span className="zigzag-label">Show More</span>
            </button>
          )}

          {/* EXPANDABLE CONTENT (BELOW BUTTON) */}
          {children && (
            <div
              className={`zigzag-extra-wrapper ${showMore ? "expanded" : ""
                }`}
            >
              <div className="zigzag-extra">
                {children}
              </div>
            </div>
          )}
        </motion.div>


        {/* IMAGE */}
        <motion.div
          className="zigzag-image"
          initial={{ opacity: 0, x: imageStartX }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true, amount: 0.4 }}
          transition={{ duration: 2.8, ease: [0.16, 1, 0.3, 1] }}
        >
          <img src={image} alt={title} />
        </motion.div>

      </div>
    </section>
  );
};

export default ZigZag;
